module.exports = __webpack_public_path__ + "assets/img/bridge-m.ffd2064.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/bridge-m.jpg
// module id = Xz/J
// module chunks = 0